import React, { PropTypes } from 'react'
import classNames from 'classnames'
import PaintSwatch from './PaintSwatch'

const PaintFillGrid = ({ paints, selectedPaint, onSelectPaintFill, className }) => (
  <div className={classNames(['paintfill-grid', className])}>
    <div className="paintfill-grid-label">NON-TRANSLUCENT</div>
    <div className="paintfill-grid-swatches">
      {paints.filter(paint => !paint.isTranslucent).map(paint =>
        <PaintSwatch key={paint.id}
          paint={paint}
          selected={!!selectedPaint && paint.id === selectedPaint.id}
          onClick={onSelectPaintFill} />
      )}
    </div>
    {paints.filter(paint => paint.isTranslucent).length > 0 &&
      <div className="paintfill-grid-label">TRANSLUCENT</div>
    }
    {paints.filter(paint => paint.isTranslucent).length > 0 &&
      <div className="paintfill-grid-swatches">
        {paints.filter(paint => paint.isTranslucent).map(paint =>
          <PaintSwatch key={paint.id}
            paint={paint}
            selected={!!selectedPaint && paint.id === selectedPaint.id}
            onClick={onSelectPaintFill} />
        )}
      </div>
    }
  </div>
)

PaintFillGrid.propTypes = {
  className: PropTypes.string,
  paints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  selectedPaint: PropTypes.shape({
    id: PropTypes.number,
  }),
  onSelectPaintFill: PropTypes.func.isRequired,
} 

export default PaintFillGrid;